import { parsePhoneNumber } from 'libphonenumber-js';
import * as api from '../api.js';

function toE164(contactId) {
  const raw = String(contactId || '').startsWith('+') ? String(contactId) : `+${contactId}`;
  try {
    const parsed = parsePhoneNumber(raw);
    if (parsed?.isValid()) return parsed.number;
  } catch {
    // Keep the typed value when it is not a real number yet.
  }
  return raw;
}

export const register = async (set, get) => {
  const contact = get().contactInput;
  // Reset email and hasEmail when starting new registration
  get().setEmail('');
  get().setHasEmail(false);
  
  const { success, failure } = await api.registerContact({
    contact: {
      contactId: toE164(contact.contactId),
      type: contact.type,
    },
  });
  window.gtag('event', 'phone_provided', {
    phone_number: contact,
    userId: get().user?._id
  });
  if (failure || !success) {
    return { failure };
  }
  const { user, hasEmail, isNewLead } = success;
  if (user) {
    get().updateUser({ user, calle: 'register' });
  }
  // Store hasEmail flag to conditionally show email field
  if (hasEmail !== undefined) {
    get().setHasEmail(hasEmail);
  }
  get().setContactStatus('verify');
  if (isNewLead) {
    get().sendFBEvent({ eventName: 'Lead' });
  }
};

export const verifyContact = async ({ otp }, set, get) => {
  const contact = get().contactInput;
  const { success, failure } = await api.verifyContact({
    contact: {
      contactId: toE164(contact.contactId),
      type: contact.type,
    },
    code: otp,
  });
  if (failure) {
    set(
      { contactModalError: failure.message || 'Invalid OTP' },
      false,
      { type: 'verify' }
    );
    set({ otp: '' }, false, { type: 'verify' });
    return { failure };
  }
  const { user, token, planSlug } = success;
  window.gtag('event', 'phone_verified', {
    phone_number: contact,
    userId: get().user?._id || user?._id
  });
  if (token) {
    // This is a login/signup
    window.gtag("event", "login", {
      method: "SMS"
    });
    await get().postLogin({ token, user, planSlug });
    
    // Update email after verification completes (user is now logged in)
    // Only update if provided and user doesn't have email
    const hasEmail = get().hasEmail;
    const email = get().email?.trim();
    if (!hasEmail && email) {
      await get().updateUserPref({ email });
    }
    if (success.isNewUser) {
      get().sendFBEvent({ eventName: 'CompleteRegistration' });
    }
  } else {
    await get().updateUser({ user, calle: 'verify' });
  }
  await get().setContactStatus(null);
  return { success };
};
